import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Button, Flex } from "@theme-ui/components";
import { LiveCode } from "../components/code";
import Prism from "@theme-ui/prism";
export const _frontmatter = {
  "title": "Buttons"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Buttons`}</h1>
    <p>{`Examples of combining `}<inlineCode parentName="p">{`@theme-ui/components`}</inlineCode>{` to create and style buttons.`}</p>
    <hr></hr>
    <h2>{`Numeric Label`}</h2>
    <p>{`A side by side button alongside a `}<inlineCode parentName="p">{`NavLink`}</inlineCode>{` to another location.`}</p>
    <LiveCode containerSx={`sx={{display: 'flex', justifyContent: 'space-around' }}`} mdxType="LiveCode">{`<Flex sx={{ border: '1px solid', borderColor: 'primary', width: 'fit-content', borderRadius: 3, cursor: 'pointer' }}>
  <Flex sx={{placeItems: 'center'}}>
    <Button sx={{display: 'flex', alignItems: 'center', borderTopRightRadius: 0, borderBottomRightRadius: 0}}>
      <svg sx={{ mr: 1 }} viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
      Like
    </Button>
  </Flex>
  <Flex sx={{ placeItems: 'center' }}>
    <NavLink sx={{ borderRadius: '3' }}>
      2459
    </NavLink>
  </Flex>
</Flex>`}</LiveCode>
    <h2>{`Icon Button`}</h2>
    <p>{`Theme UI includes an `}<inlineCode parentName="p">{`IconButton`}</inlineCode>{` component.`}</p>
    <LiveCode containerSx={`sx={{display: 'flex', justifyContent: 'space-around' }}`} mdxType="LiveCode">{`<IconButton
  aria-label='Toggle dark mode'>
  <svg sx={{ fill: 'text', height: '14px', width: '14px'}} viewBox="0 0 20 20">
    <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/>
  </svg>
</IconButton>`}</LiveCode>
    <h2>{`Labeled Buttons`}</h2>
    <p>{`SVG elements can be used inside other elements and styled with the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop as well.`}</p>
    <LiveCode containerSx={`sx={{display: 'flex', justifyContent: 'space-around' }}`} mdxType="LiveCode">{`<Button>
  <svg sx={{ height: '14px', width: '14px', fill: 'background', marginRight: 1 }} viewBox="0 0 20 20">
    <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/>
  </svg>
  Download
</Button>`}</LiveCode>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      